<template>
  <v-container fluid class="pa-0 mt-4">
    <v-divider class="mb-4" />

    <v-row no-gutters align="center" class="mb-2">
      <div class="text-subtitle-1">Approvazione uso logo</div>
      <v-spacer />
      <v-btn color="primary" small :disabled="!companyCode" @click="apriNuovo">
        <v-icon left small>add</v-icon> Aggiungi
      </v-btn>
    </v-row>

    <v-alert v-if="!companyCode" type="info" dense text>
      Salva prima l'anagrafica del cliente per poter registrare le approvazioni d'uso del logo.
    </v-alert>

    <v-data-table v-else :headers="headers" :items="righe" hide-default-footer :items-per-page="-1" dense
      no-data-text="Nessuna approvazione registrata">
      <template v-slot:item.dataApprovazione="{ item }">
        {{ formattaData(item.dataApprovazione) }}
      </template>
      <template v-slot:item.inUso="{ item }">
        <v-chip x-small :color="item.inUso ? 'success' : 'grey lighten-2'" :text-color="item.inUso ? 'white' : undefined">
          {{ item.inUso ? 'SI' : 'NO' }}
        </v-chip>
      </template>
      <template v-slot:item.azioni="{ item }">
        <v-icon class="mr-2" small @click="apriModifica(item)">edit</v-icon>
        <v-icon small @click="eliminaRiga(item)">delete</v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogNuovo" max-width="450px" persistent>
      <v-card>
        <v-card-title class="text-h6">{{ modalitaModifica ? "Modifica" : "Nuova" }} approvazione uso logo</v-card-title>
        <v-card-text>
          <v-row class="ma-0 pa-0 mt-2">
            <v-text-field v-model.number="editedItem.id" label="Id" type="number" dense hide-details
              :disabled="modalitaModifica" class="mb-4 mr-4" />
            <campo-data v-model="editedItem.dataApprovazione" label="Data approvazione" />
          </v-row>

          <v-text-field v-model="editedItem.approvatoDa" label="Approvato da" dense hide-details class="mt-4 mb-4" />
          <v-text-field v-model="editedItem.documento" label="Documento" dense hide-details class="mb-4" />
          <v-switch v-model="editedItem.inUso" label="Logo ancora in uso" dense hide-details class="mt-0" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogNuovo = false">Annulla</v-btn>
          <v-btn color="primary" @click="salva">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  get_approvazioni_loghi,
  salva_approvazione_logo,
  aggiorna_approvazione_logo,
  elimina_approvazione_logo,
} from "@/api/api.clienti.js";
import CampoData from "./CampoData.vue";

export default {
  name: "ApprovazioneLoghi",

  components: { CampoData },

  props: {
    companyCode: { type: String, default: "" },
    tipoCertificazione: { type: String, required: true, validator: (v) => ["FSC", "PEFC"].includes(v) },
  },

  data: () => ({
    righe: [],
    dialogNuovo: false,
    modalitaModifica: false,
    editedItem: {},

    headers: [
      { text: "Anno", value: "anno", sortable: false },
      { text: "Id", value: "id", sortable: false },
      { text: "Data approvazione", value: "dataApprovazione", sortable: false },
      { text: "Approvato da", value: "approvatoDa", sortable: false },
      { text: "Documento", value: "documento", sortable: false },
      { text: "In uso", value: "inUso", sortable: false },
      { text: "Azioni", value: "azioni", sortable: false },
    ],
  }),

  watch: {
    companyCode(nuovo) {
      if (nuovo) this.caricaDati();
    },
  },

  methods: {
    async caricaDati() {
      if (!this.companyCode) return;
      const res = await get_approvazioni_loghi({ CompanyCode: this.companyCode, TipoCertificazione: this.tipoCertificazione });
      this.righe = res.data;
    },

    apriNuovo() {
      this.modalitaModifica = false;
      this.editedItem = {
        companyCode: this.companyCode,
        tipoCertificazione: this.tipoCertificazione,
        id: null,
        dataApprovazione: new Date().toISOString().substr(0, 10),
        approvatoDa: "",
        documento: "",
        inUso: true,
      };
      this.dialogNuovo = true;
    },

    apriModifica(item) {
      this.modalitaModifica = true;
      this.editedItem = { ...item };
      this.dialogNuovo = true;
    },

    async salva() {
      if (!this.editedItem.id || this.editedItem.id <= 0) {
        this.$toast.alert("Inserisci un Id numerico positivo");
        return;
      }
      if (!this.editedItem.dataApprovazione) {
        this.$toast.alert("Inserisci la data di approvazione");
        return;
      }

      const res = this.modalitaModifica
        ? await aggiorna_approvazione_logo(this.editedItem)
        : await salva_approvazione_logo(this.editedItem);

      if (res.data === "OK") {
        this.dialogNuovo = false;
        await this.caricaDati();
      } else {
        this.$toast.alert(res.data);
      }
    },

    async eliminaRiga(item) {
      let confirm = await this.$confirm.open(
        "Elimina approvazione",
        "Eliminare l'approvazione <b>#" + item.id + "</b> del " + this.formattaData(item.dataApprovazione) + "?"
      );
      if (!confirm) return;

      const res = await elimina_approvazione_logo(item);
      if (res.data === "OK") {
        await this.caricaDati();
      } else {
        this.$toast.alert(res.data);
      }
    },

    formattaData(data) {
      if (!data) return "";
      try {
        return this.$i2kFunctions.formatISODate(data.substring(0, 10));
      } catch {
        return data;
      }
    },
  },

  mounted() {
    this.caricaDati();
  },
};
</script>
